import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM, { createRoot } from "react-dom/client";
import MyRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./components/utils/reportWebVitals";
import { SSOProvider } from "./contexts/SSOContext";

const container = document.getElementById("root");
const root = createRoot(container);
window.HEADER_HEIGHT = 56;
window.notifyColor = "#51a197";

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
